window.showModal = (id) => {
  const modal = document.getElementById(id)

  if (!modal) {
    return
  }

  modal.classList.add("modal--open")
}

window.closeModal = (id, remove = false) => {
  const modal = document.getElementById(id)

  if (!modal) {
    return
  }

  if (remove) {
    return modal.remove()
  }

  modal.classList.remove("modal--open")

  for (const form of modal.querySelectorAll("form")) {
    form.reset()
  }

  for (const loader of modal.querySelectorAll(".loader-handler.loading")) {
    loader.classList.remove("loading")
  }

  for (const element of modal.querySelectorAll(
    "[data-remove-on-modal-close]",
  )) {
    element.remove()
  }
}
